export default function AppLogo({ width }) {
  const props = { src: '/logo.svg', width }

  return (
    <img {...props} alt="Warpgate logo" />
  )
}
